import * as React from 'react';
import PageButton from './PageButton';
import IPaginationButtonProps from './types';

const FirstPage: React.FC<IPaginationButtonProps> = (props) => {
  return (
    <PageButton {...props} className="control">
      <svg
        className="pagination-icon first-page"
        width="17"
        height="17"
        viewBox="0 0 17 17"
        data-testid="first-page-icon"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M14.6921 4.40193L10.5886 8.50541L14.6921 12.6089C15.1046 13.0213 15.1046 13.6876 14.6921 14.1001C14.2797 14.5125 13.6134 14.5125 13.2009 14.1001L8.34654 9.24573C7.93408 8.83326 7.93408 8.16698 8.34654 7.75452L13.2009 2.90015C13.3985 2.70211 13.6668 2.59082 13.9465 2.59082C14.2263 2.59082 14.4945 2.70211 14.6921 2.90015C15.094 3.31261 15.1046 3.98947 14.6921 4.40193Z" />
        <path d="M2.00146 3.55C2.00146 2.9701 2.44918 2.5 3.00146 2.5C3.55375 2.5 4.00146 2.9701 4.00146 3.55V13.45C4.00146 14.0299 3.55375 14.5 3.00146 14.5C2.44918 14.5 2.00146 14.0299 2.00146 13.45V3.55Z" />
      </svg>
    </PageButton>
  );
};

export default FirstPage;
